<template>
  <div class="application">
    <toptitle :title1="titlework" />
    <section class="choose">
      <div class="down">
        <van-checkbox v-model="checked" @click="all" class="input"
          >全选(总计{{ subBody.length }}次)</van-checkbox
        >
      </div>
      <div @click="isShowDatePicker" class="choosedate">
        {{ year }}年{{ month }}月
      </div>
    </section>
    <van-popup v-model="showDatePicker" position="bottom">
      <van-picker
        show-toolbar
        title="选择年月"
        :columns="columns"
        @confirm="onConfirm1"
        @cancel="onCancel"
      />
    </van-popup>
    <van-checkbox-group style="margin-bottom: 60px" v-model="result">
      <section class="reason" v-for="(item, index) in subBody" :key="index">
        <p>
          <van-checkbox @click="false1" :name="index"></van-checkbox>
          {{ item.C_WORK_DATE }}
          <span>/{{ item.DESCR }}</span>
        </p>
        <div>
          <van-cell title="实际打卡时间" :value="item.CARDDTTM" />
        </div>
        <div>
          <van-cell title="签卡时间" :value="item.CLASSES" />
        </div>
        <div>
          <van-cell
            required
            title="申请补卡原因"
            @click="showPopup(index)"
            is-link
            :value="item.C_CARD_REASON"
          />
          <van-popup v-model="show">
            <van-picker
              title="标题"
              show-toolbar
              :columns="columns1"
              @confirm="onConfirm"
              @cancel="onCancel"
            />
          </van-popup>
        </div>
        <van-field v-model="item.COMMENTS" label="备注" />
      </section>
    </van-checkbox-group>
    <section class="blank1"></section>
    <div class="blank" @click="submit">提交</div>
    <div v-if="show1" class="button-bt1"></div>
  </div>
</template>

<script>
import { Toast } from "vant";
import toptitle from "../toptitle";
import {
  getAttendDataApi,
  applicationDataApi,
  appRecordDataApi,
} from "../../request/api";
import loginVue from "../../views/login.vue";
import { throttle } from "../../utils/throttle";

export default {
  data() {
    name: "application";
    let month = new Date().getMonth() + 1;
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    } 
    return {
      titlework: "申请补卡",
      value: month,
      option3: [],
      value3: "",
      checked: false,
      result: [],
      show: false,
      show2: false,
      subBody: [],
      index: 0,
      columns1: ["10-考勤机故障", "20-漏打卡"],
      show1: false,
      result1: [],
      day: "01",
      showDatePicker: false,
      columns: [
        // 第一列
        {
          values: [],
          defaultIndex: 1,
        },
        // 第二列
        {
          values: [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
          ],
          defaultIndex: 1,
        },
      ],
      year: "",
    };
  },
  methods: {
    onConfirm1(index) {
      this.same(index[0], index[1], this.day);
      this.year = index[0];
      this.month = index[1];
      this.showDatePicker = false;
    },
    isShowDatePicker() {
      this.showDatePicker = true;
    },
    false1() {
      if (this.result1 != this.result) {
        this.checked = false;
      }
    },
    all() {
      if (this.checked) {
        this.subBody.forEach((item, index) => {
          this.result.push(index);
          this.result1.push(index);
        });
      } else {
        this.result = [];
      }
    },
    showPopup(val) {
      this.show = true;
      this.index = val;
    },
    same(s, m, d) {
      let par = {
        security: {
          signTxt: "OTQ5QKE3NJJFNDQ0Q0JFM0JDNURDNJM2MTG4NKIWQJM3=",
          ipAddress: "10.19.185.14",
          system: "SELF",
          pubkeyRmk: "Z7PCKFDMBPVHGS0ZGDQT",
        },
        parameters: {
          EMPLID: sessionStorage.getItem("EMPLID"),
          DATE: s + "-" + m + "-" + d,
        },
      };
      appRecordDataApi(par).then((res) => {
        if (res.CODE == 1) {
          let { Count, subBody } = res.DATA;
          this.subBody = subBody;
        }
      });
    },
    onConfirm(value, index) {
      this.subBody[this.index].C_CARD_REASON = value;
      this.show = false;
    },
    onConfirm2(value, index) {
      value += ":00";
      this.subBody[this.index].C_CARD_TM = value;
      this.show2 = false;
    },
    onCancel() {
      this.show = false;
      this.show2 = false;
      this.showDatePicker = false;
    },
    submit() {
      this.show1 = true;
      let arr = [];
      let newArr = [];
      console.log(this.subBody);
      this.subBody.forEach((item, index) => {
        arr.push({
          C_CARD_DT: item.C_WORK_DATE,
          C_CARD_REASON: item.C_CARD_REASON,
          C_CARD_TM: item.CLASSES,
          EMPLID: sessionStorage.getItem("EMPLID"),
          COMMENTS: item.COMMENTS ? item.COMMENTS : "",
        });
      });
      this.result.forEach((item) => {
        arr.forEach((val, index) => {
          if (item == index) {
            newArr.push(val);
          }
        });
      });
      if (!newArr.length) {
        Toast.fail("数据不能为空");
        this.show1 = false;
        return;
      }
      for (let i = 0; i < newArr.length; i++) {
        if (!newArr[i].C_CARD_REASON) {
          this.show1 = false;
          Toast.fail("请填写补卡原因");
          return;
        }
        if (newArr[i].C_CARD_REASON == "10-考勤机故障") {
          newArr[i].C_CARD_REASON = "10";
        } else if (newArr[i].C_CARD_REASON == "20-漏打卡") {
          newArr[i].C_CARD_REASON = "20";
        } else if (newArr[i].C_CARD_REASON == "30-公出") {
          newArr[i].C_CARD_REASON = "30";
        } else {
          newArr[i].C_CARD_REASON = "";
        }
      }
      let params = {
        EMPLID: sessionStorage.getItem("EMPLID"),
        LINES: newArr,
      };
      applicationDataApi(params).then((res) => {
        if (res.C_BAS_INFO_RES.RESULTCODE == 1) {
          Toast.success("提交成功");
          this.$router.push("/checkrec");
        } else {
          Toast.fail(res.C_BAS_INFO_RES.RESULTMSG);
          this.show1 = false;
        }
      });
    },
  },
  components: {
    toptitle,
  },
  created() {
    var myDate = new Date();
    this.year = myDate.getFullYear();
    let month = myDate.getMonth() + 1;
    if (month < 10) {
      this.month = "0" + month;
    }
    this.same(this.year, this.month, this.day);
    let year1 = this.year - 1;
    let year2 = this.year + 1;
    this.columns[0].values.push(year1, this.year, year2);
    this.columns[1].defaultIndex = month - 1;
  },
};
</script>

<style lang="less" scoped >
.choose {
  display: flex;
  /deep/.van-dropdown-menu {
    width: 50%;
  }
  .down {
    width: 50%;
    height: 48px;
    background: white;
    .input {
      margin-top: 13px;
      margin-left: 30px;
      font-size: 15px;
    }
  }
  .choosedate {
    background: white;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #323233;
    font-size: 15px;
    border-left: 1px solid #e5e5e5;
    width: 50%;
  }
}
.button-bt1 {
  position: fixed;
  bottom: 0;
  display: flex;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background: rgba(0, 0, 0, 0.2);
  width: 100%;
}
.reason {
  font-size: 15px;
  background: white;
  margin: 10px 10px 0;
  padding: 0 13px;
  border-radius: 10px;
  p {
    text-align: right;
    width: 100%;
    line-height: 44px;
    /deep/.van-checkbox {
      float: left;
      margin-top: 12px;
    }
  }
  /deep/.van-cell {
    padding: 10px 0 10px 16px;
    color: #8f8f8f;
  }
}
/deep/.van-field__control {
  text-align: right;
}
.blank {
  position: fixed;
  bottom: 0;
  height: 44px;
  width: 100%;
  line-height: 44px;
  text-align: center;
  background: #733e2a;
  color: white;
  font-size: 18px;
}
.blank1 {
  height: 60px;
}
/deep/ .van-popup--center {
  width: 80%;
}
</style>